<template>
  <v-text-field
    data-private
    outlined
    dense
    required
    hide-details="auto"
    data-testid="password-input-passwordField"
    :label="label || `${$t('common.users.password')}*`"
    :value="password"
    :prepend-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    :rules="passwordRules"
    :type="show ? 'text' : 'password'"
    @click:prepend-inner="show = !show"
    @input="$emit('onChange', $event)"
  >
  </v-text-field>
</template>
<script>
export default {
  name: 'PasswordField',

  props: {
    password: {
      type: String,
    },
    passwordRules: {
      type: Array,
      default: () => [],
    },
    label: String,
  },

  data() {
    return {
      show: false,
    }
  },
}
</script>
